var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login_contenter" },
    [
      _c("loginHeader"),
      _c(
        "div",
        { staticClass: "login_content", class: { isPopFrame: _vm.isPopFrame } },
        [
          _c("div", { staticClass: "login_cont" }, [
            _c(
              "div",
              { staticClass: "login_form" },
              [
                _c("closeModalBtn", { ref: "closeModalBtn" }),
                _c("div", { staticClass: "login_item" }, [
                  _c("div", { staticClass: "login_type" }, [
                    _c("span", { staticClass: "login_type_item active" }, [
                      _vm._v(_vm._s(_vm.$t("huanYingZhuCe"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "login_form_cont" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "registerForm",
                          attrs: {
                            rules: _vm.rules,
                            model: _vm.regForm,
                            "label-width": "0px",
                            size: "medium",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "regTel" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("ShouJiHaoYouXiang"),
                                  readonly:
                                    _vm.btnStatus.registerBtn ||
                                    _vm.forAutoComplete,
                                  "auto-complete": "false",
                                },
                                model: {
                                  value: _vm.regForm.regTel,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.regForm, "regTel", $$v)
                                  },
                                  expression: "regForm.regTel",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "item-error el-form-item__error",
                                  attrs: { slot: "error" },
                                  slot: "error",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.checkTelEmailErrorMsg) +
                                      " "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.toLogina,
                                          expression: "toLogina",
                                        },
                                      ],
                                      staticStyle: { cursor: "pointer" },
                                      on: { click: _vm.toLoginFn },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("QuDengLu")) + ">>")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm.showCaptcha.register
                            ? _c(
                                "el-form-item",
                                { attrs: { prop: "verificationCode" } },
                                [
                                  _c("el-input", {
                                    staticStyle: {
                                      width: "calc(100% - 150px)",
                                    },
                                    attrs: {
                                      placeholder: _vm.$t("TuXingYanZhengMa"),
                                      readonly:
                                        _vm.btnStatus.registerBtn ||
                                        _vm.forAutoComplete,
                                      maxlength: "6",
                                      "auto-complete": "false",
                                    },
                                    model: {
                                      value: _vm.regForm.verificationCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.regForm,
                                          "verificationCode",
                                          $$v
                                        )
                                      },
                                      expression: "regForm.verificationCode",
                                    },
                                  }),
                                  _c("img", {
                                    staticClass: "imgCode",
                                    attrs: {
                                      src: _vm.imgCodeData.regNoteImgCode,
                                      alt: _vm.$t("YanZhengMa"),
                                      title: _vm.$t("DianJiQieHuanYanZhengMa"),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.loginChangeCodeFn(
                                          "regNoteImgCode"
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "telVerificationCode" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("YanZhengMa"),
                                  maxlength: "6",
                                  readonly:
                                    _vm.btnStatus.registerBtn ||
                                    _vm.forAutoComplete,
                                  "auto-complete": "false",
                                },
                                model: {
                                  value: _vm.regForm.telVerificationCode,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.regForm,
                                      "telVerificationCode",
                                      $$v
                                    )
                                  },
                                  expression: "regForm.telVerificationCode",
                                },
                              }),
                              _c(
                                "el-button",
                                {
                                  staticClass: "getNoteCodeBtn",
                                  attrs: {
                                    type: "text",
                                    disabled: _vm.noteCodeBtn,
                                  },
                                  on: { click: _vm.getNoteCode },
                                },
                                [_vm._v(_vm._s(_vm.telCodeText))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "regPwd" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    placeholder: _vm.$t("MiMa"),
                                    readonly:
                                      _vm.btnStatus.registerBtn ||
                                      _vm.forAutoComplete,
                                    type: !_vm.showPwdIcon
                                      ? "password"
                                      : "text",
                                    clearable: _vm.windowInnerWidth > 499,
                                    "auto-complete": "false",
                                  },
                                  model: {
                                    value: _vm.regForm.regPwd,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.regForm, "regPwd", $$v)
                                    },
                                    expression: "regForm.regPwd",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-input__icon iconfont",
                                    class: {
                                      "yyq-icon-hide": !_vm.showPwdIcon,
                                      "yyq-icon-view": _vm.showPwdIcon,
                                    },
                                    attrs: { slot: "suffix" },
                                    on: { click: _vm.showPwdFn },
                                    slot: "suffix",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c("el-input", {
                                attrs: {
                                  readonly: _vm.btnStatus.registerBtn,
                                  placeholder: _vm.$t("YaoQingMaFeiBiTian"),
                                  clearable: "",
                                  "auto-complete": "false",
                                },
                                model: {
                                  value: _vm.regForm.invitationCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.regForm, "invitationCode", $$v)
                                  },
                                  expression: "regForm.invitationCode",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "protocol",
                              attrs: { prop: "checked" },
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    disabled: _vm.btnStatus.registerBtn,
                                  },
                                  model: {
                                    value: _vm.regForm.checked,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.regForm, "checked", $$v)
                                    },
                                    expression: "regForm.checked",
                                  },
                                },
                                [
                                  _c("i18n", {
                                    attrs: { path: "WoYiYueDuBingTongYi" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "tos",
                                        fn: function () {
                                          return [
                                            _c(
                                              "el-link",
                                              {
                                                staticClass: "sy_reg_atc",
                                                attrs: {
                                                  type: "primary",
                                                  href:
                                                    _vm.$urls.dtranxUrl +
                                                    "/home/UserAgreement?locale=" +
                                                    _vm.language,
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("YongHuXieYi")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "privacy",
                                        fn: function () {
                                          return [
                                            _c(
                                              "el-link",
                                              {
                                                staticClass: "sy_reg_atc",
                                                attrs: {
                                                  type: "primary",
                                                  href:
                                                    _vm.$urls.dtranxUrl +
                                                    "/home/PrivacyPolicy?locale=" +
                                                    _vm.language,
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("YinSiShengMing")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "protocol" },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    disabled: _vm.btnStatus.loginNoteBtn,
                                  },
                                  model: {
                                    value: _vm.isKeepMore,
                                    callback: function ($$v) {
                                      _vm.isKeepMore = $$v
                                    },
                                    expression: "isKeepMore",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("30TianNeiJiZhuWo")))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { size: "large" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "loginBtn",
                                  attrs: {
                                    type: "primary",
                                    loading: _vm.btnStatus.registerBtn,
                                  },
                                  on: { click: _vm.registerSubmit },
                                },
                                [_vm._v(_vm._s(_vm.$t("ZhuCeBingDengLu")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "register_title" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "YiGeZhangHaoKeDengLuSuoYouShuYiQiXiaChanPin"
                            )
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "sy_login_bottom sy_text_c" },
                    [
                      _c("i18n", {
                        attrs: { path: "YiYouZhangHao" },
                        scopedSlots: _vm._u([
                          {
                            key: "link",
                            fn: function () {
                              return [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      type: "primary",
                                      href: "javascript:;",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toPath("/")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(_vm._s(_vm.$t("QuDengLu")) + " "),
                                    _c("i", { staticClass: "el-icon-right" }),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }